import { FunctionComponent, useEffect, useState } from 'react'
import { WidgetProps } from '@rjsf/core'
import { Checkbox } from '@dxp-module/common'
import { Box } from '@mui/material'
import checkboxesStyles from './checkboxes.styles'

type EnumOption = {
  value: string
  label: string
}

const Checkboxes: FunctionComponent<WidgetProps> = props => {
  const styles = checkboxesStyles()
  const { id, value, onChange, options } = props
  const [updatedValues, setUpdatedValues] = useState<string[]>(value || [])

  const handleChange = (id: string, newValue: boolean) => {
    setUpdatedValues(prevValues => {
      const updatedValues = [...prevValues]

      if (newValue) {
        updatedValues.push(id)
      } else {
        const index = updatedValues.indexOf(id)
        if (index > -1) {
          updatedValues.splice(index, 1)
        }
      }

      return updatedValues
    })
  }

  useEffect(() => {
    onChange(updatedValues)
  }, [updatedValues])

  return (
    <Box className={styles.root}>
      {(options?.enumOptions as EnumOption[]).map(
        ({ value: optionValue, label }) => (
          <Checkbox
            id={`${id}-${optionValue}`}
            key={optionValue}
            label={label}
            onChange={isChecked => handleChange(optionValue, isChecked)}
            value={value.includes(optionValue)}
            classes={{ itemRoot: styles.itemRoot, item: styles.item }}
          />
        )
      )}
    </Box>
  )
}

export default Checkboxes
